import { ReactComponent as BackStepOutlinedIcon } from 'assets/icons/back-step-outlined.svg';

export default BackStepOutlinedIcon;
